export default {"src":"/_next/static/media/trazado-pink.4feb7730.svg","height":39,"width":146,"blurWidth":0,"blurHeight":0};